import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class HttpGenericService {

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string, private auth: AuthService) { }

  get(url: string, options?: {}): Observable<any> {
    return this.http.get(`${this.baseUrl}api/${url}`, this.optionsArgs(options))
      .pipe(
        tap(_ => console.log(`Listando datos de la url ${url}`)),
        catchError(this.handleError)
      );
  }

  post(url: string, body: any, options?: {}): Observable<any> {
    return this.http.post(`${this.baseUrl}api/${url}`, body, this.optionsArgs(options))
      .pipe(
        tap(_ => console.log(`Agregando el registro ${body}`)),
        catchError(this.handleError)
      );
  }

  put(url: string, body: any, options?: {}): Observable<any> {
    return this.http.put(`${this.baseUrl}api/${url}`, body, this.optionsArgs(options)).pipe(
      tap(_ => console.log(`Actualizando el registro ${body}`)),
      catchError(this.handleError)
    );
  }

  delete(url: string, options?: {}): Observable<any> {
    return this.http.delete(`${this.baseUrl}api/${url}`, this.optionsArgs(options)).pipe(
      tap(_ => console.log(`Eliminando el registro: url ${url}`)),
      catchError(this.handleError)
    );
  }

  login(usuario: string, contrasena: string) : Promise<any> {
    let modelo = {
      usuario,
      contrasena
    };

    return this.http.post(`${this.baseUrl}api/token`, modelo).toPromise();
  }

  private optionsArgs(opts?: any): any {
    const responseType = (opts) ? opts.responseType : 'json';

    const token = this.auth.obtenerSesionUsuario() ? this.auth.obtenerSesionUsuario().token : '';
    
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    const options = {
      responseType: responseType,
      headers
    };

    return options;
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('Ha ocurrido un error:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }

    console.log(error);
  
    return throwError(error);
  }
}
